import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSuperOpsPodDataByContactId } from 'services/pod';
import { IPodData } from 'services/pod/types';
import { convertSimplifiedToPodData } from 'store/pod/helpers';

interface IProps {
  psaId: number;
  contactId: string;
}

export const ThunkGetSuperOpsDataByContactId = createAsyncThunk<IPodData, IProps>(
  'pod/getSuperOpsPodDataByContactId',
  async ({ psaId, contactId }) =>
    getSuperOpsPodDataByContactId(psaId, contactId)
      .then(r => r.data)
      .then(data => convertSimplifiedToPodData(data)),
);
